import PropTypes from 'prop-types';
import { MdDownload } from 'react-icons/md';
import styles from './ExportButton.module.css';

const ExportButton = ({
  onClick,
  disabled = false,
  buttonText = 'Export',
  showIcon = true,
}) => (
  <button
    className={styles.exportBtn}
    onClick={onClick}
    disabled={disabled}
  >
    {showIcon && <MdDownload />} {buttonText}
  </button>
);

ExportButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  buttonText: PropTypes.string,
  showIcon: PropTypes.bool,
};

export default ExportButton;
